export const buildPathWithSearchParams = (
  path: string,
  searchParams: URLSearchParams,
) => {
  const searchString = searchParams.toString();
  return {
    pathname: path,
    ...(searchString && { search: `?${searchString}` }),
  };
};

/**
 * @example slugify('Christmas Party!') // => 'christmas-party'
 */
export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
